import React from "react";
import {
  customersData,
  droneEcosystemData,
  ourPartnersData,
} from "../common/Helper";

const Customer = () => {
  return (
    <div className="">
      {/* <div className="container">
        <h3 className=" fs_48 ff_inter text-center letter_spacing color_darkgray fw-bold">
          Our Happy <span className=" color_blue">customers</span>
        </h3>
        <div className="row">
          {customersData.map((obj, index) => {
            return (
              <>
                <div key={index} className="col-lg-4 col-sm-6 mt-lg-5 mt-4">
                  <div className="customer_box h-100 p-4">
                    <div className="d-flex align-items-center gap-3">
                      <img width={55} src={obj.image} alt="user image" />
                      <h4 className="mb-0 fw-bold ff_raleway color_darkgray fs_17">
                        {obj.heading}
                      </h4>
                    </div>
                    <p
                      style={{
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        WebkitLineClamp: 5,
                        cursor: "pointer",
                        position: "relative",
                      }}
                      title={obj.paragraph}
                      className="mt-3 ff_raleway fw-medium color_darkgray "
                    >
                      {obj.paragraph}
                    </p>
                    <img width={136} src={obj.starImage} alt="star_image" />
                  </div>
                </div>
              </>
            );
          })}
        </div>
        <div className="p-3 mt-5">
          <div className="container pt-lg-4">
            <h3 className=" fw-bold ff_inter text-center color_darkgray fs_48">
              Our Partners
            </h3>
            <div className="row col-md-9 mx-auto pb-lg-4 justify-content-between">
              {ourPartnersData.map((item, index) => {
                return (
                  <>
                    <div key={index} className="col-md-4 p-4 mt-4">
                      <a href="#">
                        <img
                          className="w-100 h-100 rounded-2"
                          src={item.image}
                          alt=" Our Partners logo"
                        />
                      </a>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
          <h4 className="text-white text-center fs_48 fw-bold ff_inter mb-0">
            Indian Drone Ecosystem
          </h4>
          <p className="text-white text-center fs_24 ff_inter mb-0 mt-2">
            Explore 540+ companies across 21 categories
          </p>
          <div className="row justify-content-start justify-content-sm-center">
            {droneEcosystemData.map((obj, index) => {
              return (
                <>
                  <div
                    key={index}
                    className="col-lg-2 col-sm-4 col-6 mt-lg-5 mt-4"
                  >
                    <div className="image_card text-center p-3">
                      <img width={80} src={obj.image} alt="image" />
                    </div>
                    <p className=" ff_inter fs_21 text-white text-center mb-0 mt-3">
                      {obj.paragraph}
                    </p>
                  </div>
                </>
              );
            })}
          </div>
          <div className="d-flex justify-content-center mt-5">
            <button className=" bg-white ff_inter fs_17 fw-medium px-5 py-2 border-0 rounded-2">
              View All
            </button>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Customer;
